<template>
  <div class="phone">
    <van-field
      v-model="pass"
      type="password"
      clearable
      :label="label"
      :placeholder="placeholder"
      @input="changePass"
    />
  </div>
</template>
<script>
export default {
  props: {
    label: {
      type: String,
      default: ""
    },
    placeholder: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      pass: ""
    };
  },
  methods: {
    changePass() {
      this.$emit("changePass", this.pass);
    }
  }
};
</script>

<style lang="less" scoped>
.phone {
  margin: 16px 12px 0;
  ::v-deep .van-cell {
    background: #f6f7f8;
    border-radius: 20px;
  }
  ::v-deep .van-count-down {
    color: rgba(0, 0, 0, 0.38);
    font-size: 12px;
    font-weight: 400;
    line-height: 14px;
  }
  ::v-deep .van-field__label {
    font-size: 12px;
    font-weight: 500;
    color: #000;
  }
  ::v-deep .van-field__control {
    font-size: 12px;
  }
}
</style>
